import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { History, RefreshCw, TrendingDown, TrendingUp } from "lucide-react";

const RateHistoryDialogSection = ({ ctx }) => {
  const {
    loadingRateHistory,
    rateHistoryData,
    rateHistoryOpen,
    setRateHistoryOpen
  } = ctx;
  return (
    <>
      <Dialog open={rateHistoryOpen} onOpenChange={setRateHistoryOpen}>
        <DialogContent className="max-w-2xl">
          <DialogHeader>
            <DialogTitle>
              <History className="w-5 h-5 inline mr-2 text-primary" />
              Rate History - {rateHistoryData.material_name}
            </DialogTitle>
          </DialogHeader>
          
          <div className="space-y-4">
            {/* Current Rate */}
            <div className="p-4 bg-primary/10 rounded-lg">
              <p className="text-xs uppercase tracking-widest text-slate-600 mb-1">Current Rate</p>
              <p className="font-heading font-bold text-2xl text-primary">₹{rateHistoryData.current_rate?.toFixed(2)}</p>
            </div>
            
            {/* Rate History Timeline */}
            {loadingRateHistory ? (
              <div className="text-center py-8">
                <RefreshCw className="w-6 h-6 mx-auto animate-spin text-primary" />
                <p className="text-sm text-slate-500 mt-2">Loading history...</p>
              </div>
            ) : rateHistoryData.history?.length === 0 ? (
              <div className="text-center py-8 text-slate-500">
                <History className="w-12 h-12 mx-auto mb-3 text-slate-300" />
                <p>No rate changes recorded yet.</p>
                <p className="text-xs mt-1">Rate history will appear here when the rate is updated.</p>
              </div>
            ) : (
              <div className="max-h-96 overflow-y-auto">
                <table className="w-full">
                  <thead className="sticky top-0 bg-slate-100">
                    <tr>
                      <th className="text-left py-2 px-3 text-xs uppercase tracking-widest text-slate-600">Date</th>
                      <th className="text-right py-2 px-3 text-xs uppercase tracking-widest text-slate-600">Old Rate</th>
                      <th className="text-right py-2 px-3 text-xs uppercase tracking-widest text-slate-600">New Rate</th>
                      <th className="text-right py-2 px-3 text-xs uppercase tracking-widest text-slate-600">Change</th>
                      <th className="text-left py-2 px-3 text-xs uppercase tracking-widest text-slate-600">Changed By</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rateHistoryData.history.map((record, idx) => (
                      <tr key={record.id || idx} className="border-b border-slate-100 hover:bg-slate-50">
                        <td className="py-3 px-3 text-sm text-slate-700">
                          {new Date(record.created_at).toLocaleDateString('en-IN', { 
                            day: '2-digit', month: 'short', year: 'numeric',
                            hour: '2-digit', minute: '2-digit'
                          })}
                        </td>
                        <td className="py-3 px-3 text-right font-mono text-sm">₹{record.old_rate?.toFixed(2)}</td>
                        <td className="py-3 px-3 text-right font-mono text-sm font-semibold">₹{record.new_rate?.toFixed(2)}</td>
                        <td className={`py-3 px-3 text-right font-mono text-sm font-semibold ${
                          record.change_percent > 0 ? 'text-error' : record.change_percent < 0 ? 'text-success' : ''
                        }`}>
                          <div className="flex items-center justify-end">
                            {record.change_percent > 0 ? (
                              <TrendingUp className="w-3 h-3 mr-1" />
                            ) : record.change_percent < 0 ? (
                              <TrendingDown className="w-3 h-3 mr-1" />
                            ) : null}
                            {record.change_percent > 0 ? '+' : ''}{record.change_percent?.toFixed(1)}%
                          </div>
                        </td>
                        <td className="py-3 px-3 text-sm text-slate-600">{record.changed_by_name}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
          
          <div className="flex justify-end pt-4">
            <button onClick={() => setRateHistoryOpen(false)} className="btn-outline">Close</button>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default RateHistoryDialogSection;
